"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

require("core-js/modules/es.json.stringify.js");

var _message = require("@/components/dialog/message");

var _settings = require("@/model/settings");

var _index = require("@/model/assets/index");

var _checkInput = require("@/assets/js/checkInput");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { getUserInfo } from 'model/account/account';
var _default = {
  mixins: [_commonMixin.default],
  // 用户已绑定的账号数据，验证码类型，手机/邮箱，是否禁用，修改数据，验证码位置，背景色
  props: ["accountInfo", "isChangePwd", "type_num", "type", "disabled", "changeData", "verificate", "bgColor"],
  data: function data() {
    var isMobile = this.type === "mobile";
    var area = +this.accountInfo.area || 86;
    var mobile, email;

    if (!this.changeData) {
      mobile = this.accountInfo.mobile;
      email = this.accountInfo.email;
    }

    var validatorMobild = function validatorMobild(rule, value, callback) {
      var result = (0, _checkInput.checkMobile)(value);

      if (result && result.tip) {
        callback(new Error(result.tip));
      } else {
        callback();
      }
    };

    return {
      isFetchCode: false,
      countDown: -1,
      // 倒计时
      countDownTimer: null,
      // 倒计时容器
      numLabel: isMobile ? "手机号码" : "邮箱账号",
      codeLabel: isMobile ? "手机验证码" : "邮箱验证码",
      isMobile: isMobile,
      // 是否用于手机号输入框
      all_areacode: {},
      // 所有区号
      formData: {
        area: area,
        mobile: mobile,
        email: email,
        mobile_code: "",
        email_code: ""
      },
      formRules: {
        area: [{
          required: true,
          message: this.translateTitle("\u8BF7\u9009\u62E9\u533A\u53F7"),
          trigger: "change"
        }],
        // mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatorMobild, trigger: 'blur' }],
        mobile: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u624B\u673A\u53F7"),
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u90AE\u7BB1"),
          trigger: "blur"
        }, {
          pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,
          message: this.translateTitle("\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E"),
          trigger: "blur"
        }],
        mobile_code: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u624B\u673A\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          max: 6,
          message: this.translateTitle("\u9A8C\u8BC1\u7801\u5E94\u4E3A 6 \u4F4D\u6570\u5B57"),
          trigger: "blur"
        }],
        email_code: [{
          required: true,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u90AE\u7BB1\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }, {
          max: 6,
          message: this.translateTitle("\u9A8C\u8BC1\u7801\u5E94\u4E3A 6 \u4F4D\u6570\u5B57"),
          trigger: "blur"
        }]
      },
      checkPwdStatus: false
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAreaCode();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 清除验证码
    clearCode: function clearCode() {
      this.formData.mobile_code = "";
      this.formData.email_code = "";
    },
    // 获取用户信息
    getUserInfo: function getUserInfo() {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取手机区号
    getAreaCode: function getAreaCode() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(_settings.SETTING_SV_ID.static_sms_country).then(function (res) {
                  if (res.status === 200) {
                    _this2.all_areacode = res.data;
                  } else {
                    (0, _message.showMessage)({
                      message: res.msg
                    });
                  }
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    changePwdStatus: function changePwdStatus(status) {
      return status;
    },
    filterData: function filterData(val) {
      var str = this.$refs.searchSelect.$data.selectedLabel;

      if (str.length > 6) {
        this.$refs.searchSelect.$data.selectedLabel = str.substr(0, 5);
      }
    },
    // 获取验证码
    getCode: function getCode() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var type, isChangePwd, isMobile, _this3$formData, mobile, area, email;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this3.isFetchCode) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                _this3.isFetchCode = true;
                type = _this3.type_num;
                isChangePwd = _this3.isChangePwd, isMobile = _this3.isMobile, _this3$formData = _this3.formData, mobile = _this3$formData.mobile, area = _this3$formData.area, email = _this3$formData.email; // if (isChangePwd) {
                //   // this.$emit("checkPwdStatus", status => (this.checkPwdStatus = status));
                //   if (!this.checkPwdStatus) {
                //     this.isFetchCode = false;
                //     return;
                //   }
                // }
                // 手机

                if (!isMobile) {
                  _context4.next = 23;
                  break;
                }

                if (!(!mobile || /^\s*$/.test(mobile))) {
                  _context4.next = 9;
                  break;
                }

                _this3.isFetchCode = false; // this.$refs.dBindForm.validateField("mobile");

                return _context4.abrupt("return");

              case 9:
                if (!(type == 3)) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 12;
                return (0, _index.bindMobileCode)((0, _objectSpread2.default)({
                  type: type,
                  mobile: mobile,
                  area: area
                }, _this3.geetParam)).then(function (res) {
                  _this3.sendSuccess(res);
                });

              case 12:
                _context4.next = 21;
                break;

              case 14:
                if (!(type == 4)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 17;
                return (0, _index.changeMobileCode)().then(function (res) {
                  _this3.sendSuccess(res);
                });

              case 17:
                _context4.next = 21;
                break;

              case 19:
                _context4.next = 21;
                return (0, _index.verifyMobileCode)().then(function (res) {
                  _this3.sendSuccess(res);
                });

              case 21:
                _context4.next = 33;
                break;

              case 23:
                if (!(!email || /^\s*$/.test(email))) {
                  _context4.next = 26;
                  break;
                }

                _this3.isFetchCode = false; // this.$refs.dBindForm.validateField("email");

                return _context4.abrupt("return");

              case 26:
                if (!(type == 6)) {
                  _context4.next = 31;
                  break;
                }

                _context4.next = 29;
                return (0, _index.bindEmailCode)({
                  type: type,
                  email: email
                }).then(function (res) {
                  _this3.sendSuccess(res);
                });

              case 29:
                _context4.next = 33;
                break;

              case 31:
                _context4.next = 33;
                return (0, _index.verifyEmailCode)().then(function (res) {
                  _this3.sendSuccess(res);
                });

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 发送成功
    sendSuccess: function sendSuccess(res) {
      var _this4 = this;

      if (res.status === 200) {
        this.countDown = 60;
        this.countDownTimer = setInterval(function () {
          if (_this4.countDown <= 0) {
            clearInterval(_this4.countDownTimer);
            _this4.isFetchCode = false;
            _this4.countDown = -1;
            return;
          }

          _this4.countDown -= 1;
        }, 1000);
        (0, _message.showMessage)({
          message: this.translateTitle("\u53D1\u9001\u6210\u529F"),
          type: "success"
        });
      } else {
        this.isFetchCode = false;
        (0, _message.showMessage)({
          message: res.msg
        });
      }
    },
    // 登录
    submitForm: function submitForm() {
      // dBindForm
      var statusData;
      var isMobile = this.isMobile,
          formData = this.formData;
      this.$refs.dBindForm.validate(function (valid) {
        if (valid) {
          if (isMobile) {
            delete formData.email;
            delete formData.email_code;
          } else {
            delete formData.area;
            delete formData.mobile;
            delete formData.mobile_code;
          }

          statusData = formData;
        } else {
          statusData = false;
        }
      });
      return JSON.parse(JSON.stringify(statusData));
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearInterval(this.countDownTimer);
    next();
  }
};
exports.default = _default;